// extracted by mini-css-extract-plugin
export default {"menu":"Sidebar_menu__dxY8w"};